import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { BookOpen, Clock, ChevronRight, Bot, Calculator, FileText, Settings } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Default articles (fallback if database is empty)
const defaultArticles = [
  {
    id: '1',
    category: 'Estate Planning',
    category_color: 'bg-blue-100 text-blue-800',
    border_color: 'border-t-blue-500',
    read_time: '6 min read',
    title: '2026 Business & Personal: A Forward-Thinking Approach to Estate Planning',
    description: 'As we approach 2026, estate planning is evolving to address the futuristic needs of business and personal wealth management. This guide explores innovative strategies.',
    author: 'PSN Team (AI Generated)',
    content: `As we approach 2026, estate planning is evolving to address the futuristic needs of business and personal wealth management. This comprehensive guide explores innovative strategies that combine traditional planning with modern technology.

Key considerations for 2026 estate planning include:

1. Digital Asset Integration
With the rise of cryptocurrencies, NFTs, and digital businesses, estate plans must now account for these new asset classes. Proper documentation and secure transfer mechanisms are essential.

2. Business Succession Planning
For business owners, creating a clear succession plan is crucial. This includes identifying successors, training programs, and legal structures that ensure smooth transitions.

3. Tax Optimization Strategies
Understanding the current tax landscape and planning for potential changes helps maximize wealth transfer while minimizing tax burdens for beneficiaries.

4. Healthcare Directives
Modern healthcare planning goes beyond traditional directives to include considerations for telehealth, genetic testing data, and advanced medical technologies.

5. Family Communication
Open dialogue with family members about estate plans helps prevent disputes and ensures everyone understands their roles and responsibilities.

Professional Services Nationwide can help you navigate these complex considerations and create a comprehensive estate plan tailored to your unique situation.`
  },
  {
    id: '2',
    category: 'Artificial Intelligence',
    category_color: 'bg-green-100 text-green-800',
    border_color: 'border-t-green-500',
    read_time: '6 min read',
    title: "Warren Buffett's Enduring Wisdom: Navigating the AI Frontier with Timeless Principles",
    description: "Even in the rapidly evolving age of artificial intelligence, the investment and business philosophy of Warren Buffett offers invaluable guidance for navigating uncertainty.",
    author: 'PSN Team (AI Generated)',
    content: `Even in the rapidly evolving age of artificial intelligence, the investment and business philosophy of Warren Buffett offers invaluable guidance for navigating uncertainty and building lasting value.

Buffett's Core Principles Applied to AI:

1. Circle of Competence
Buffett advises staying within your circle of competence. When it comes to AI, this means understanding the technology's capabilities and limitations before making investment or implementation decisions.

2. Long-Term Thinking
While AI promises rapid transformation, Buffett's patient approach reminds us to focus on sustainable value creation rather than chasing short-term AI hype.

3. Quality Over Quantity
Not all AI solutions are created equal. Buffett's emphasis on quality suggests investing in AI tools and companies with proven track records and clear value propositions.

4. Understanding the Business
Before implementing AI in your business, understand how it will create value. Buffett's approach of thoroughly understanding a business before investing applies equally to AI adoption.

5. Risk Management
AI introduces new risks including data privacy, algorithmic bias, and technological disruption. Buffett's conservative approach to risk provides a framework for responsible AI adoption.

At Professional Services Nationwide, we help businesses navigate the AI landscape with wisdom and prudence, ensuring technology serves your long-term goals.`
  },
  {
    id: '3',
    category: 'Accounting',
    category_color: 'bg-orange-100 text-orange-800',
    border_color: 'border-t-orange-500',
    read_time: '15 min read',
    title: 'Long Term Mindset',
    description: "Warren Buffett's Financial Statement 'Rules of Thumb' - Essential principles for analyzing businesses and making sound financial decisions.",
    author: 'PSN Team',
    content: `Warren Buffett's Financial Statement "Rules of Thumb" provide essential principles for analyzing businesses and making sound financial decisions.

Key Financial Statement Rules:

Income Statement Analysis:
- Look for consistent gross profit margins above 40%
- Selling, General & Administrative expenses should be below 30% of gross profit
- Research & Development costs indicate innovation investment
- Interest expenses should be minimal for healthy companies
- Net earnings should show consistent growth over time

Balance Sheet Indicators:
- Current ratio above 1.5 indicates good liquidity
- Low debt-to-equity ratios suggest financial stability
- Retained earnings growth shows reinvestment capability
- Goodwill should be analyzed carefully for acquisition-heavy companies

Cash Flow Considerations:
- Operating cash flow should exceed net income
- Capital expenditures should be sustainable
- Free cash flow indicates true earning power

Quality Indicators:
- Return on equity above 15% consistently
- Return on assets showing efficient asset utilization
- Profit margins stable or improving over time

At Professional Services Nationwide, we apply these time-tested principles to help our clients understand their financial position and make informed decisions for long-term success.`
  },
  {
    id: '4',
    category: 'Artificial Intelligence',
    category_color: 'bg-purple-100 text-purple-800',
    border_color: 'border-t-purple-500',
    read_time: '5 min read',
    title: 'FUTURE OF AI IN ACCOUNTING',
    description: 'AI is shifting accounting from manual processing to intelligent, real-time, advisory-driven services.',
    author: 'AI GENERALIST',
    content: `AI is shifting accounting from manual processing to intelligent, real-time, advisory-driven services. This transformation is reshaping how accounting professionals deliver value to their clients.

The Evolution of AI in Accounting:

1. Automated Data Entry
AI-powered systems can now automatically capture, categorize, and enter financial data with minimal human intervention, reducing errors and freeing up accountants for higher-value work.

2. Real-Time Financial Insights
Machine learning algorithms analyze financial data in real-time, providing instant insights into cash flow, profitability, and financial health.

3. Predictive Analytics
AI can forecast future financial trends, helping businesses make proactive decisions rather than reactive ones.

4. Fraud Detection
Advanced AI systems can identify unusual patterns and potential fraud much faster than traditional methods.

5. Advisory Services
With routine tasks automated, accountants are evolving into strategic advisors, using AI-generated insights to guide business decisions.

6. Natural Language Processing
AI can now interpret and respond to financial queries in natural language, making financial information more accessible to non-experts.

The Future Outlook:
- Increased automation of compliance and reporting
- More sophisticated predictive modeling
- Enhanced client communication through AI assistants
- Integration of AI across all accounting functions

Professional Services Nationwide stays at the forefront of these developments, ensuring our clients benefit from the latest AI advancements in accounting.`
  },
  {
    id: '5',
    category: 'Accounting',
    category_color: 'bg-green-100 text-green-800',
    border_color: 'border-t-green-500',
    read_time: '5 min read',
    title: 'Accounting Review',
    description: 'PSN Provides Reliable Service',
    author: 'Client-Rebecca',
    content: `PSN Provides Reliable Service

As a small business owner, finding reliable accounting services was crucial for my company's growth. Professional Services Nationwide has exceeded my expectations in every way.

What I Love About PSN:

1. Personalized Attention
Unlike larger firms where you're just a number, PSN takes the time to understand my business and its unique needs. They treat me like a valued partner, not just another client.

2. Timely Communication
I never have to chase down my accountant for answers. The PSN team is proactive in their communication and always responds promptly to my questions.

3. Expert Guidance
The team's expertise has helped me navigate complex tax situations and make informed financial decisions. Their advice has saved my business thousands of dollars.

4. Modern Technology
PSN uses cutting-edge accounting software that makes it easy for me to access my financial information anytime, anywhere.

5. Trustworthy Partnership
I trust PSN with my business's financial health. They've proven their reliability time and time again.

I highly recommend Professional Services Nationwide to any business owner looking for dependable, professional accounting services.

- Rebecca, Small Business Owner`
  },
  {
    id: '6',
    category: 'Accounting',
    category_color: 'bg-green-100 text-green-800',
    border_color: 'border-t-green-500',
    read_time: '5 min read',
    title: 'Accounting Review',
    description: 'Why I use PSN Service',
    author: 'Client',
    content: `Why I use PSN Service

After years of struggling with unreliable accounting services, I finally found Professional Services Nationwide. Here's why they've become my go-to accounting partner.

My Experience with PSN:

1. Comprehensive Services
PSN handles all my accounting needs under one roof - bookkeeping, tax preparation, payroll, and financial consulting. No more juggling multiple providers.

2. Accuracy and Attention to Detail
Their team catches errors before they become problems. Their meticulous approach gives me peace of mind knowing my finances are in good hands.

3. Cost-Effective Solutions
PSN provides exceptional value for the services they offer. They've helped me identify cost savings I never knew existed.

4. Stress-Free Tax Season
Tax season used to be my most dreaded time of year. With PSN, it's now a smooth, organized process. They handle everything and keep me informed every step of the way.

5. Business Growth Support
Beyond just crunching numbers, PSN has been instrumental in helping my business grow. Their financial insights have guided many of my most successful business decisions.

If you're looking for an accounting partner who truly cares about your success, look no further than Professional Services Nationwide.

- Satisfied Client`
  },
  {
    id: '7',
    category: 'Bookkeeping & Accounting Automation',
    category_color: 'bg-orange-100 text-orange-800',
    border_color: 'border-t-orange-500',
    read_time: '1 month',
    title: 'Bookkeeping & Accounting Yearend Checklist for Small Businesses & Entrepreneurs',
    description: 'Why Your Year-End Close is Your Most Powerful Business Tool',
    author: 'PSN Team',
    content: `Why Your Year-End Close is Your Most Powerful Business Tool

The year-end close isn't just an accounting requirement—it's an opportunity to gain valuable insights into your business's performance and set the stage for success in the coming year.

Year-End Checklist for Small Businesses:

Financial Records Review:
□ Reconcile all bank accounts
□ Review and reconcile credit card statements
□ Verify accounts receivable balances
□ Confirm accounts payable accuracy
□ Review inventory counts and valuations

Tax Preparation:
□ Gather all income documentation
□ Organize expense receipts and records
□ Review estimated tax payments
□ Identify potential deductions
□ Consult with tax professional on strategies

Payroll Tasks:
□ Verify employee information accuracy
□ Review W-4 forms for updates
□ Prepare for W-2 and 1099 distribution
□ Reconcile payroll tax deposits
□ Update benefit enrollments

Financial Analysis:
□ Compare actual vs. budgeted performance
□ Analyze profit margins by product/service
□ Review cash flow patterns
□ Assess debt levels and payment schedules
□ Evaluate pricing strategies

Planning for Next Year:
□ Set financial goals and budgets
□ Plan for major purchases or investments
□ Review insurance coverage
□ Update business plans
□ Schedule regular financial reviews

Professional Services Nationwide can help you navigate your year-end close efficiently and effectively.`
  },
  {
    id: '8',
    category: 'Artificial Intelligence',
    category_color: 'bg-green-100 text-green-800',
    border_color: 'border-t-green-500',
    read_time: '5 min read',
    title: 'Bookkeeping & Accounting Yearend Checklist for Small Businesses & Entrepreneurs',
    description: 'Explore essential bookkeeping and accounting practices for year-end 2025, focusing on leveraging AI tools and technology to enhance efficiency.',
    author: 'PSN Team (AI Generated)',
    content: `Explore essential bookkeeping and accounting practices for year-end 2025, focusing on leveraging AI tools and technology to enhance efficiency.

AI-Enhanced Year-End Accounting:

1. Automated Reconciliation
Modern AI tools can automatically match transactions across accounts, dramatically reducing the time spent on reconciliation and minimizing human error.

2. Smart Document Processing
AI-powered OCR and document processing can extract data from receipts, invoices, and statements automatically, organizing your records with minimal manual input.

3. Predictive Cash Flow Analysis
Machine learning algorithms can analyze your historical data to predict year-end cash flow, helping you make informed decisions about expenses and investments.

4. Intelligent Expense Categorization
AI systems learn your categorization preferences and automatically classify expenses, ensuring consistent and accurate financial records.

5. Real-Time Financial Dashboards
AI-driven dashboards provide instant visibility into your year-end financial position, highlighting areas that need attention.

6. Automated Compliance Checks
AI tools can scan your records for potential compliance issues, helping you address problems before they become costly mistakes.

Implementation Tips:
- Start with one AI tool and expand gradually
- Ensure data quality before automation
- Train your team on new technologies
- Maintain human oversight of AI outputs
- Regular review and adjustment of AI settings

Professional Services Nationwide combines traditional accounting expertise with cutting-edge AI tools to deliver superior year-end services for small businesses and entrepreneurs.`
  }
];

const Resources = () => {
  const [activeFilter, setActiveFilter] = useState('All Topics');
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedArticle, setExpandedArticle] = useState(null);

  const filters = [
    { name: 'All Topics', icon: null },
    { name: 'Artificial Intelligence', icon: <Bot size={16} /> },
    { name: 'Accounting', icon: <Calculator size={16} /> },
    { name: 'Estate Planning', icon: <FileText size={16} /> },
    { name: 'Bookkeeping & Accounting Automation', icon: <Settings size={16} /> },
  ];

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const response = await axios.get(`${API}/articles`);
      if (response.data && response.data.length > 0) {
        setArticles(response.data);
      } else {
        // Use default articles if database is empty
        setArticles(defaultArticles);
      }
    } catch (error) {
      console.error('Error fetching articles:', error);
      // Use default articles on error
      setArticles(defaultArticles);
    } finally {
      setLoading(false);
    }
  };

  const filteredArticles = activeFilter === 'All Topics' 
    ? articles 
    : articles.filter(article => article.category === activeFilter);

  return (
    <div className="min-h-screen bg-gray-50" data-testid="resources-page">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-900 via-blue-700 to-indigo-900 text-white py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <div className="flex justify-center mb-6">
              <div className="p-4 bg-white/10 rounded-2xl backdrop-blur-sm">
                <BookOpen className="w-12 h-12 md:w-16 md:h-16 text-blue-200" />
              </div>
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6" data-testid="resources-title">
              Resources
            </h1>
            <p className="text-lg md:text-xl text-blue-100 max-w-3xl mx-auto leading-relaxed">
              Explore our collection of articles and insights on AI, accounting, estate planning, 
              and business automation to help you stay informed and make better decisions.
            </p>
          </div>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="py-8 bg-white border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-wrap justify-center gap-3">
            {filters.map((filter) => (
              <button
                key={filter.name}
                onClick={() => setActiveFilter(filter.name)}
                className={`inline-flex items-center px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 ${
                  activeFilter === filter.name
                    ? 'bg-blue-800 text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
                data-testid={`filter-${filter.name.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {filter.icon && <span className="mr-2">{filter.icon}</span>}
                {filter.name}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="flex justify-center items-center h-64">
              <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-800"></div>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {filteredArticles.map((article) => (
                <article
                  key={article.id}
                  className={`bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden border-t-4 ${article.border_color}`}
                  data-testid={`article-${article.id}`}
                >
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-4">
                      <span className={`inline-flex items-center px-3 py-1 rounded-full text-xs font-medium ${article.category_color}`}>
                        {article.category}
                      </span>
                      <span className="flex items-center text-gray-500 text-sm">
                        <Clock size={14} className="mr-1" />
                        {article.read_time}
                      </span>
                    </div>
                    
                    <h3 className="text-lg font-bold text-gray-900 mb-3 line-clamp-2">
                      {article.title}
                    </h3>
                    
                    <p className="text-gray-600 text-sm mb-4 line-clamp-3">
                      {article.description}
                    </p>
                    
                    <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                      <span className="text-sm text-gray-500 flex items-center">
                        <span className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mr-2">
                          <span className="text-blue-800 text-xs font-bold">
                            {article.author.charAt(0)}
                          </span>
                        </span>
                        {article.author}
                      </span>
                      <button
                        onClick={() => setExpandedArticle(expandedArticle === article.id ? null : article.id)}
                        className="inline-flex items-center text-blue-800 font-medium text-sm hover:text-blue-900 transition-colors"
                        data-testid={`read-more-${article.id}`}
                      >
                        {expandedArticle === article.id ? 'Close' : 'Read More'}
                        <ChevronRight size={16} className={`ml-1 transition-transform ${expandedArticle === article.id ? 'rotate-90' : ''}`} />
                      </button>
                    </div>
                  </div>
                  
                  {/* Expanded Content */}
                  {expandedArticle === article.id && (
                    <div className="px-6 pb-6 pt-2 bg-gray-50 border-t border-gray-100">
                      <div className="prose prose-sm max-w-none text-gray-700 whitespace-pre-line">
                        {article.content}
                      </div>
                    </div>
                  )}
                </article>
              ))}
            </div>
          )}
          
          {!loading && filteredArticles.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-500 text-lg">No articles found for this category.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Resources;
